// extracted by mini-css-extract-plugin
export default {"font-renta":"FormOptions_font-renta__v+qEV","formOptions":"FormOptions_formOptions__ydBTQ","title":"FormOptions_title__vT7Am","item":"FormOptions_item__i5ao8"};